import { render, staticRenderFns } from "./NoticiasMercadoMaisPopular.vue?vue&type=template&id=0219b563&"
import script from "./NoticiasMercadoMaisPopular.vue?vue&type=script&lang=js&"
export * from "./NoticiasMercadoMaisPopular.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasMercadoMaisPopular.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports